import { Component, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { PaContextMenuComponent } from '../../../../shared/ui-kit/pa-context-menu/pa-context-menu.component';

@Component({
  selector: 'app-menu-view',
  standalone: true,
  imports: [PaContextMenuComponent],
  templateUrl: './menu-view.component.html',
  styleUrls: ['./menu-view.component.scss'],
})
export class MenuViewComponent  implements OnInit {
  items: MenuItem[] | undefined;
  
  constructor() { }

      ngOnInit(): void {
        this.items = [
            {
                label: 'Обновить',
                icon: 'pi pi-refresh'
            },
            {
                label: 'Экспорт',
                icon: 'pi pi-upload'
            }
        ]
    }

}
